import { useQuery } from "@tanstack/react-query";

import { api } from "utils/axios";
import useUrlParams from "utils/urlParms";

const GET_STUDENTS = "get-students";

const getStudents = async (params) => {
  try {
    const response = await api.get(`/student`, { params });
    return response.data;
  } catch (e) {
    console.error(e, "Error fetching Student");
  }
};

const useGetStudent = () => {
  const { getUrlParams } = useUrlParams();
  const params = getUrlParams();

  return useQuery({
    queryKey: [GET_STUDENTS, params],

    queryFn: () => getStudents(params),
  });
};

export { useGetStudent, GET_STUDENTS };
